(function () {
  'use strict';

  function norm(s) { return String(s || '').trim().toLowerCase(); }
  function savedModel() { try { return localStorage.getItem('bsk_model') || ''; } catch (e) { return ''; } }
  function fit(list, model) { return window.BSKFit ? window.BSKFit(list, model) : false; }
  function typesFor(model) { return window.BSKTypes ? window.BSKTypes(model) : ''; }
  function letterOf(name) { return (window.BSK_TYPES || {})[norm(name)] || ''; }
  /* Which model property a product needs: null = none (AirPods, wallets) */
  function modelRule(title, isCaseType) {
    var t = norm(title);
    if (/airpod|wallet|protector|holder/.test(t)) return null;
    if (/stride/.test(t)) return { list: 'stride', prop: 'Selected Model' };
    if (!isCaseType && /glass/.test(t)) return { list: 'glass', prop: 'Device' };
    return { list: 'full', prop: 'Device' };
  }
  /* Pick the first variant whose case type is made for the model */
  function pickVariant(pairs, model) {
    var ok = typesFor(model);
    for (var i = 0; i < pairs.length; i++) { var l = letterOf(pairs[i][0]); if (!ok || !l || ok.indexOf(l) > -1) return pairs[i][1]; }
    return null;
  }
  function money(cents) {
    var v = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₹' + v;
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Only phone cases count towards Buy 2 Get 1 Free (keep in sync with sections/mini-cart.liquid) */
  var NOT_DEAL = /airpod|airtag|wallet|protector|lens ga?u?a?rd|pop ?slider|pop ?socket|suction|holder|charger|power bank/;
  function isDeal(title) { return !NOT_DEAL.test(norm(title)); }
  function caseCount(cart) {
    return cart.items.filter(function (i) { return isDeal(i.product_title); }).reduce(function (s, i) { return s + i.quantity; }, 0);
  }
  function offerText(n) {
    if (!n) return '';
    var r = n % 3;
    return r === 0 ? '<strong>Your free case is unlocked!</strong>' : r === 1 ? 'Add <strong>2 more cases</strong> and get 1 free' : 'Add <strong>1 more case</strong> and it’s free';
  }
  function refreshCart() { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
  function openCart() { var d = document.getElementById('mini-cart'); if (d) d.open = true; }

  /* ---------- Upsell forms inside the cart drawer: attach the saved phone model ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-bsk-upsell')) return;
    var list = form.getAttribute('data-bsk-upsell');
    if (!list) return;
    var m = fit(list, savedModel());
    var input = form.querySelector('[data-bsk-upsell-model]');
    if (m && input) { input.value = m; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    window.location.href = form.getAttribute('data-url');
  }, true);

  /* ---------- Added-to-cart popup ---------- */
  var pop;
  function buildPop() {
    pop = document.createElement('div');
    pop.className = 'bsk-added';
    pop.hidden = true;
    pop.innerHTML =
      '<div class="bsk-added__overlay" data-close></div>' +
      '<div class="bsk-added__panel" role="dialog" aria-modal="true" aria-label="Added to cart">' +
        '<div class="bsk-added__head"><button type="button" class="bsk-added__x" data-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 3l14 14M17 3L3 17"/></svg></button><p>Added to cart</p></div>' +
        '<div class="bsk-added__body">' +
          '<div class="bsk-added__item" data-item></div>' +
          '<p class="bsk-added__offer" data-offer hidden></p>' +
          '<div class="bsk-added__actions"><button type="button" class="bsk-added__btn bsk-added__btn--ghost" data-close>Continue shopping</button><button type="button" class="bsk-added__btn bsk-added__btn--go" data-view>View cart</button></div>' +
          '<div class="bsk-added__recs" data-recs hidden><p class="bsk-added__recs-title"><span>Recommended for you</span></p><div class="bsk-added__track" data-track></div></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) close();
      if (e.target.closest('[data-view]')) { close(); setTimeout(openCart, 150); }
      var add = e.target.closest('[data-rec-add]');
      if (add) addRec(add);
    });
    pop.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-rec-variant]');
      if (!sel) return;
      var o = sel.options[sel.selectedIndex], pr = sel.closest('.bsk-rec').querySelector('[data-rec-price]');
      if (o && pr && o.getAttribute('data-price')) pr.textContent = money(+o.getAttribute('data-price'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  }
  function open() { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('is-open'); }); document.documentElement.classList.add('bsk-lock'); }
  function close() { pop.classList.remove('is-open'); document.documentElement.classList.remove('bsk-lock'); setTimeout(function () { pop.hidden = true; }, 220); }

  function renderItem(item) {
    var meta = [];
    if (item.properties) Object.keys(item.properties).forEach(function (k) { var v = item.properties[k]; if (v && k.charAt(0) !== '_') meta.push(v); });
    if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
    pop.querySelector('[data-item]').innerHTML =
      (item.image ? '<img src="' + esc(item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="" width="80" height="80">' : '') +
      '<div><p class="bsk-added__name">' + esc(item.product_title) + '</p>' +
      (meta.length ? '<p class="bsk-added__meta">' + esc(meta.join(' • ')) + '</p>' : '') +
      '<p class="bsk-added__price">' + (item.final_price === 0 ? '<span class="bsk-added__free">FREE</span>' + (item.original_price ? ' <s>' + money(item.original_price) + '</s>' : '') : money(item.final_price)) + '</p></div>' +
      '<span class="bsk-added__check" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="#12a150"/><path d="M7 12.5l3.2 3L17 9" fill="none" stroke="#fff" stroke-width="2"/></svg></span>';
  }
  function renderOffer(cart, title) {
    var el = pop.querySelector('[data-offer]');
    var t = (title && !isDeal(title)) ? '' : offerText(caseCount(cart));
    el.innerHTML = t; el.hidden = !t;
  }
  function renderRecs(productId) {
    var wrap = pop.querySelector('[data-recs]'), track = pop.querySelector('[data-track]');
    wrap.hidden = true; track.innerHTML = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = '';
        var model = savedModel(), okTypes = typesFor(model);
        (data.products || []).forEach(function (p) {
          var vs = (p.variants || []).filter(function (v) { return v.available; });
          var isCT = vs.some(function (v) { return !!letterOf(v.option1); });
          var rule = modelRule(p.title, isCT);
          if (rule && model && okTypes) {
            if (!fit(rule.list, model)) return;
            if (isCT) vs = vs.filter(function (v) { return okTypes.indexOf(letterOf(v.option1)) > -1; });
          }
          if (!vs.length) return;
          var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=400' : p.featured_image + '?width=400') : '';
          var select = vs.length > 1 || vs[0].title !== 'Default Title'
            ? '<select data-rec-variant aria-label="Choose option">' + vs.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
            : '<input type="hidden" data-rec-variant value="' + vs[0].id + '">';
          html += '<div class="bsk-rec" data-title="' + esc(p.title) + '" data-url="' + esc(p.url) + '"' + (isCT ? ' data-ct' : '') + '>' +
            '<a class="bsk-rec__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<p class="bsk-rec__name">' + esc(p.title) + '</p><p class="bsk-rec__price" data-rec-price>' + money(vs[0].price) + '</p>' +
            select + '<button type="button" class="bsk-rec__add" data-rec-add>Add to cart</button></div>';
        });
        if (html) { track.innerHTML = html; wrap.hidden = false; track.scrollLeft = 0; }
      }).catch(function () {});
  }
  function addRec(btn) {
    var card = btn.closest('.bsk-rec');
    var id = card.querySelector('[data-rec-variant]').value;
    var rule = modelRule(card.getAttribute('data-title'), card.hasAttribute('data-ct'));
    var props = {};
    if (rule) {
      var m = fit(rule.list, savedModel());
      if (!m) { window.location.href = card.getAttribute('data-url'); return; }
      props[rule.prop] = m;
    }
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); })
      .then(function (cart) { btn.textContent = 'Added ✓'; btn.classList.add('is-done'); renderOffer(cart, card.getAttribute('data-title')); refreshCart(); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; });
  }

  document.addEventListener('variant:added', function (e) {
    var drawer = document.getElementById('mini-cart');
    if (drawer && drawer.hasAttribute('open')) return; /* added from inside the cart: just refresh */
    if (!pop) buildPop();
    var v = (e.detail && e.detail.variant) || {};
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items.filter(function (i) { return i.variant_id === v.id || i.id === v.id; })[0] || cart.items[0];
      if (!item) return;
      renderItem(item);
      renderOffer(cart, item.product_title);
      renderRecs(item.product_id);
      open();
      setTimeout(refreshCart, 300);
    });
  });

  /* ---------- Cart page: make room for the Fastrr checkout button ---------- */
  /* ---------- Quick add from product cards ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bsk-quick]');
    if (!btn) return;
    e.preventDefault();
    var vattr = btn.getAttribute('data-variants');
    var rule = modelRule(btn.getAttribute('data-title'), !!vattr);
    var props = {};
    var id = +btn.getAttribute('data-bsk-quick');
    if (rule) {
      var saved = savedModel();
      if (!saved) { if (window.BSKModel) window.BSKModel.open(rule.list); else window.location.href = btn.getAttribute('data-url'); return; }
      var m = fit(rule.list, saved);
      if (!m) { window.location.href = btn.getAttribute('data-url'); return; }
      props[rule.prop] = m;
      if (vattr) {
        var pairs = vattr.split('|').map(function (x) { var i = x.lastIndexOf(':'); return [x.slice(0, i), x.slice(i + 1)]; });
        var vid = pickVariant(pairs, m);
        if (!vid) { window.location.href = btn.getAttribute('data-url'); return; }
        id = +vid;
      }
    } else if (/airpod/i.test(btn.getAttribute('data-title'))) {
      window.location.href = btn.getAttribute('data-url'); return;
    }
    btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw r; btn.classList.remove('is-loading'); document.dispatchEvent(new CustomEvent('variant:added', { detail: { variant: { id: id } } })); })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = btn.getAttribute('data-url'); });
  });

  function cartPageFastrr() {
    document.querySelectorAll('.cart__checkout-button').forEach(function (b) {
      var prev = b.previousElementSibling;
      if (prev && prev.classList.contains('shiprocket-headless')) return;
      var d = document.createElement('div');
      d.className = 'shiprocket-headless';
      d.setAttribute('data-type', 'cart');
      b.parentNode.insertBefore(d, b);
    });
  }
  cartPageFastrr();
})();
